import { Proving } from 'model'
import React from 'react'

export const CurrentProvingContext = React.createContext<
  [Proving, () => Promise<any>]
>([null, () => void 0] as [any, any])
